import React, { useEffect, useRef, useState } from 'react';
import anime from 'animejs';
import Divider from "../components/Divider";
import {Col, Row, Container} from "react-bootstrap";
import "./About.css";

function About() {
    const titleRef = useRef(null);
    const textRef = useRef(null);
    const imageRef = useRef(null);
    const sectionTitleRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && !isVisible) {
                    setIsVisible(true);
                    
                    // Section title animation
                    anime({
                        targets: sectionTitleRef.current,
                        translateY: [50, 0],
                        opacity: [0, 1],
                        easing: 'easeOutExpo',
                        duration: 1200,
                        delay: 200,
                    });

                    // Title animation
                    anime({
                        targets: titleRef.current,
                        translateY: [50, 0],
                        opacity: [0, 1],
                        easing: 'easeOutExpo',
                        duration: 1200,
                        delay: 500,
                    });

                    // Text animation
                    anime({
                        targets: textRef.current,
                        translateY: [30, 0],
                        opacity: [0, 1],
                        easing: 'easeOutExpo',
                        duration: 1200,
                        delay: 800,
                    });

                    // Image animation
                    anime({
                        targets: imageRef.current,
                        scale: [0.8, 1],
                        opacity: [0, 1],
                        easing: 'easeOutExpo',
                        duration: 1200,
                        delay: 1100,
                    });

                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.1
        });

        observer.observe(sectionTitleRef.current);
        observer.observe(titleRef.current);
        observer.observe(textRef.current);
        observer.observe(imageRef.current);

        return () => observer.disconnect();
    }, [isVisible]);

    const getImageHeight = () => {
        if (windowWidth < 576) return 250;
        if (windowWidth < 768) return 300;
        if (windowWidth < 992) return 400;
        return 500;
    };

    return (
        <div className="about-section" id="about">
            <Container fluid className="px-4 px-md-5">
                <div className="about-content">
                    <h2 className={`section-title ${isVisible ? 'visible' : ''}`} ref={sectionTitleRef}>Για εμάς</h2>
                    <Row className="align-items-center">
                        <Col lg={6} className="mb-4 mb-lg-0">
                            <div className="about-image-container" ref={imageRef}>
                                <img 
                                    src="/images/aboutImg.jpg" 
                                    alt="Elata Malandris" 
                                    className="about-image"
                                    style={{ height: getImageHeight() }}
                                    loading="lazy"
                                />
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="about-text-content">
                                <h2 className="about-title" ref={titleRef}>
                                    Έλατα Μαλανδρής από τον Ταξιάρχη Χαλκιδικής
                                </h2>
                                <div className="about-text" ref={textRef}>
                                    <p>Ο Ταξιάρχης Χαλκιδικής είναι γνωστός για τα υπέροχα έλατά του, που καλύπτουν μεγάλες
                                        εκτάσεις του χωριού και των γύρω περιοχών. Τα έλατα αυτά αποτελούν σημαντικό κομμάτι της
                                        τοπικής οικονομίας, καθώς η καλλιέργειά τους έχει βαθιές ρίζες στην παράδοση της
                                        περιοχής.</p>
                                    <p>Η καλλιέργεια ελάτων στο Ταξιάρχη γίνεται με μεράκι και φροντίδα, κυρίως για την
                                        παραγωγή χριστουγεννιάτικων δέντρων, τα οποία προμηθεύονται σε πολλές περιοχές της
                                        Ελλάδας.</p>
                                    <p>Οι φυσικές συνθήκες της περιοχής, με το υψόμετρο και το κλίμα της, είναι ιδανικές για την
                                        ανάπτυξη αυτών των δέντρων. Τα έλατα μεγαλώνουν αργά και σταθερά, αποκτώντας πυκνό και
                                        συμμετρικό σχήμα, χαρακτηριστικό που τα καθιστά ιδιαίτερα δημοφιλή.</p>
                                    <p>Κάθε χρόνο, ντόπιοι παραγωγοί φροντίζουν να προμηθεύσουν την αγορά με ποιοτικά δέντρα,
                                        διατηρώντας τη φήμη του Ταξιάρχη ως «το χωριό των χριστουγεννιάτικων δέντρων»</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
            <Divider/>
        </div>
    );
}

export default About;